import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-treelist-checkbox-cell',
  template: `
    <div class="text-center">
      <input class="k-checkbox" type="checkbox" kendoCheckBox [checked]="value" [disabled]="true" />
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TreelistCheckboxCellComponent {
  @Input() value: boolean;
}
